import {
  MDBAlert,
  MDBCol,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { editHuntGroup } from "../../../apiclients/streamsapi_bridge";

import { FormProvider, useForm } from "react-hook-form";
import SaveChanges from "../../topviews/saveCancel";
import HGeneralSettings from "./HGeneralSettings";
import HGRoutings from "./HGRoutings";
import HGVoicemail from "./HGVoicemail";
import { useAdminContext } from "../../adminstore/Admin-Context";
import { getImpExpStatusNew } from "../../../apiclients/CommonUtils";
import ImportProgressWarning from "../../../apiclients/ImportProgressWarning";
import ImpExpRedirectPopup from "../../../apiclients/ImpExpRedirectPopup";
import ImportUser from "../user/ImportUser";


export default function HGSettings({
  hgGeneralInfo,
  setReRender,
  executeSetting,
  setExecuteSettings,
  setIsloading,
  assocCallFlows,
  setIsSequentialGroup,
  setEdited,
  setreqFromCallFlow,
  reqFromCallFlow,
}) {
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const containerRef = useRef(null);

  const { t, i18n } = useTranslation();
  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);
  const [hgcode, sethgcode] = useState("");
  const [autoext, setAutoext] = useState(false);
  const [checkAvailbility, setCheckAvailbility] = useState("");
  const [checkAvailbilityTxt, setCheckAvailbilityTxt] = useState("");
  const [extCheckFlag, setextCheckFlag] = useState(0);
  const navigate = useNavigate();
  const [updatePHNum, setUpdatePHNum] = useState([]);
  const [removePHNum, setRemovePHNum] = useState([]);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [grpaddednumbers, setGrpAddedNumbers] = useState([]);
  const [finaladdlist, setFinalAddList] = useState([]);
  const [finalremovedlist, setFinalRemovedList] = useState([]);
  const [hGeneralSettings, setHGeneralSettings] = useState(hgGeneralInfo);
  const [selectedPhoneNum, setSelectedPhoneNum] = useState([]);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
  const [freePhoneFlag, setfreePhoneFlag] = useState(true);
  const [sourceNumber, setSourceNumber] = useState([]);
  const [hgUpdated, setHgUpdated] = useState(false);
  const [message, setMessage] = useState("");
  const [internalError, setInternalError] = useState(false);
  const [useraddednumbers, setUserAddedNumbers] = useState([]);
  const elemetsToConvert = ["playmsgtime", "bcvoicemail", "voicemail_delete"];
  const convetToInteger = ["extension", "vm_pin"];
  // const [billingGroups, setBillingGroups] = useState([]);
  const [defaultValuess, setDefaultValuess] = useState({});
  const [groupname, setGroupName] = useState("");
  // const [routingValue, setRoutingValue] = useState("");
  // const [innerroutingValue, setInnerRoutingValue] = useState("");
  const [incusersup, setIncUsersSup] = useState(true);
  const [destinationsType, setDestinationsType] = useState(-1);
  const [routDetails, setRoutDetails] = useState({});
  const [greetingsInfo, setGreetingsInfo] = useState({});
  const [didSearchError, setdidSearchError] = useState("");
  const [innerDidSearchError, setinnerDidSearchError] = useState("");
  const [showExportWarning, setShowExportWarning] = useState(false);
  const exportwarningToggle = () => setShowExportWarning(!showExportWarning);
  const [warningMessage, setWarningMessage] = useState("");
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [firstRequest, setfirstRequest] = useState(false);


  // const [timeoutFlag, setTimeOutFlag] = useState(false);
  // const [passThrouFlag, setPassThrouFlag] = useState(true);
  //Reack Hook form.
  const methods = useForm({
    defaultValues: {
      name: "",
      extension: 0,
      rec_calls: false,
      disasterphonenumber: 0,
      disablecallroute: 0,
      disasterflag: 0,
      permit_user_spam: 0,
      adddids: [],
      removedids: [],
      addedUsers: [],
      removedUsers: [],
      loc_id: 0,
      billing_grp: 0,

      routing: {
        ring_dist: 1,
        overall_ring_time: 20,
        per_seq_ring_time: 20,
        busy_or_no_answer: {
          value: "",
          destination_type: -1,
          phnumber: "",
          timeout_flag: false,
          timeout: 0,
          timeout_routing: "",
          timeout_dest_type: -1,
          cid_pass_flag: true,
          cid_pass: "",
        },
      },
      voice_mail: {
        vm_pin: 0,
        play_msg_time_stmp: false,
        email_notify: true,
        email_address: "",
        inc_user_sup: true,
        vm_delete: true,
        email_transcript: true,
        broadcast_vm_to_account: false,
        email_to_members: false,
        email_to_sup: false,
      },
    },
  });
  const [enableSaveCancel, setEnableSaveCancel] = useState(false);

  //update true and false to 1 or 0
  function convertToggleData(hgInfo) {
    elemetsToConvert.forEach((ele) => {
      if (ele in hgInfo) {
        hgInfo[ele] = hgInfo[ele] == 1 ? true : false;
      }
    });
  }

  const onCloseChanges = () => {
    reset();
    setRoutDetails({});
    setExecuteSettings(true);
  };
  const {
    formState: { dirtyFields },
    reset,
    setError,
    handleSubmit,
    watch,
  } = methods;

  const isFieldModified = Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isFieldModified);
  }, [isFieldModified]);

  const onSaveChanges = async (data) => {
    console.log("data is ::::::::::::::::::::::::::: " + JSON.stringify(data));
    console.log(
      "dirtyFields is ::::::::::::::::::::::::::: " +
        JSON.stringify(dirtyFields)
    );
    try {
      const modifiedData = {};
      for (const field of Object.keys(dirtyFields)) {
        // Check if the field is dirty and exists in the data object
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          // If the field is an object, extract modified subfields
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            modifiedData[field] = {};

            for (const subfield of Object.keys(dirtyFields[field])) {
              if (data[field].hasOwnProperty(subfield)) {
                if (
                  typeof data[field][subfield] === "object" &&
                  !Array.isArray(data[field][subfield])
                ) {
                  modifiedData[field][subfield] = {};
                  for (const subsubfield of Object.keys(
                    dirtyFields[field][subfield]
                  )) {
                    modifiedData[field][subfield][subsubfield] =
                      data[field][subfield][subsubfield];
                  }
                } else {
                  modifiedData[field][subfield] = data[field][subfield];
                }
              }
            }
          } else {
            // If it's not an object, add the entire field
            modifiedData[field] = data[field];
          }
        }
      }
      if (modifiedData) {
        if (modifiedData?.routing?.busy_or_no_answer) {
          if (!modifiedData.routing.busy_or_no_answer.destination_type) {
            modifiedData.routing.busy_or_no_answer.destination_type =
              data.routing.busy_or_no_answer.destination_type;
            const hasExtraFields = [
              "phnumber",
              "timeout",
              "timeout_flag",
              "timeout_routing",
              "destination_type", // <-- corrected key
              "cid_pass_flag",
              "cid_pass",
            ].some((key) => key in modifiedData.routing.busy_or_no_answer);

            if (
              data.routing.busy_or_no_answer.destination_type === -1 &&
              hasExtraFields
            ) {
              modifiedData.routing.busy_or_no_answer.destination_type = 4;
            }
          }

          if (
            modifiedData?.routing?.busy_or_no_answer?.phnumber &&
            modifiedData?.routing?.busy_or_no_answer?.destination_type === 4
          ) {
            modifiedData.routing.busy_or_no_answer.value =
              modifiedData.routing.busy_or_no_answer.phnumber;
            delete modifiedData.routing.busy_or_no_answer.phnumber;
          }

          if (
            modifiedData?.routing?.busy_or_no_answer?.timeout_flag !==
              undefined &&
            modifiedData?.routing?.busy_or_no_answer?.timeout_flag === false
          ) {
            if (modifiedData?.busy_or_no_answer?.timeout_dest_type) {
              delete modifiedData.routing.busy_or_no_answer.timeout_dest_type;
              delete modifiedData.routing.busy_or_no_answer.timeout_routing;
            }
          }
          if (
            modifiedData.routing.busy_or_no_answer.destination_type !== 4 &&
            modifiedData.routing.busy_or_no_answer.destination_type !== -1
          ) {
            delete modifiedData.routing.busy_or_no_answer.timeout_dest_type;
            delete modifiedData.routing.busy_or_no_answer.timeout_routing;
            delete modifiedData.routing.busy_or_no_answer.timeout_flag;
            delete modifiedData.routing.busy_or_no_answer.cid_pass_flag;
            delete modifiedData.routing.busy_or_no_answer.cid_pass;
            delete modifiedData.routing.busy_or_no_answer.phnumber;
          }
        }

        modifiedData.reqid = 9;
        modifiedData.siteid = JSON.parse(
          sessionStorage.getItem("admin_session")
        ).siteid;
        modifiedData.code = hgGeneralInfo.code;
        //alert(JSON.stringify(modifiedData));
        console.log("HG Edit feild json ::: " + JSON.stringify(modifiedData));
        setIsloading(true);
        let response = await editHuntGroup(modifiedData);
        setTimeout(() => {
          setIsloading(false);
        }, 1000);
        console.log("response before::::: " + JSON.stringify(response));
        let resdata = await response.json();
        console.log("response ::::: " + JSON.stringify(resdata));
        if (response.status === 200) {
          //setReRender(false);
          setMessage(resdata.message); // success pop up message.
          setHgUpdated(true); // enabling sucesss popup
          //reset();
          setReRender(true);
          if (reqFromCallFlow) {
            if (window.opener && window.opener?.receiveMessageFromHuntChild) {
              window.opener.receiveMessageFromHuntChild(1); // Send a message to the parent
            }
            setreqFromCallFlow(false);
            window.close();
          } // Re- Rednering the child componenet in order to stay in the same page after saving with latest updated data.
        } else if (response.status === 400) {
          if (resdata.message?.errors) {
            resdata.message.errors.forEach((err) => {
              setError(err.param_name, {
                type: "server",
                message: err.message,
              });
            });
          }
        } else if (response.status === 500) {
          setInternalError(true);
        }
      }
    } catch (e) {
      console.log(`Unable to send update Hunt User to API:${e}`);
      // setInternalError(true);
    }
  };

  function mapCatogry(title, cat) {
    switch (cat) {
      case "PBX":
        return (title += " : " + "AA Group");

      case "HUNT":
        return (title += " : " + "Hunt Group");

      case "ACD":
        return (title += " : " + "ACD Group");
    }
    return title;
  }

  useEffect(() => {
    if (Object.keys(hgGeneralInfo ?? {}).length > 0 || executeSetting) {
      convertToggleData(hgGeneralInfo);
      console.log(
        `Before resetting the data:::: ${JSON.stringify(hgGeneralInfo)}`
      );
      if (hgGeneralInfo.dids) {
        setSelectedPhoneNum(hgGeneralInfo.dids);
      }
      // alert(hgGeneralInfo?.routing?.ring_dist);
      setGreetingsInfo(hgGeneralInfo.greetings ?? {});
      // setBillingGroups(hgGeneralInfo.billingGroups);
      sethgcode(hgGeneralInfo.code);
      setGroupName(hgGeneralInfo.groupName);
      let title = hgGeneralInfo?.routing?.busy_or_no_answer?.title ?? "";
      if (title && title != "") {
        if (hgGeneralInfo?.routing?.busy_or_no_answer?.extension) {
          title += " : " + hgGeneralInfo?.routing?.busy_or_no_answer?.extension;
        }
        if (hgGeneralInfo?.routing?.busy_or_no_answer?.category) {
          const cat = hgGeneralInfo?.routing?.busy_or_no_answer?.category;
          // title = mapCatogry(title, cat);
          title += " : " + cat;
        }
      }
      const innerRouteObj =
        hgGeneralInfo?.routing?.busy_or_no_answer?.timeout_routing ?? {};
      let innerRouteValue = innerRouteObj?.title ?? "";

      if (innerRouteValue && innerRouteValue != "") {
        if (innerRouteObj?.extension) {
          innerRouteValue += " : " + innerRouteObj?.extension;
        }
        if (innerRouteObj?.category) {
          const innerCat = innerRouteObj?.category;
          // innerRouteValue = mapCatogry(innerRouteValue, innerCat);
          innerRouteValue += " : " + innerCat;
        }
      }

      setDestinationsType(
        hgGeneralInfo?.routing?.busy_or_no_answer?.destination_type != undefined
          ? parseInt(hgGeneralInfo.routing.busy_or_no_answer.destination_type)
          : -1
      );
      // setRoutDetails({
      //   routeValue: title,
      //   innerRouteValue: innerRouteValue,
      //   destinationType:
      //     hgGeneralInfo?.routing?.busy_or_no_answer?.destination_type !=
      //     undefined
      //       ? parseInt(hgGeneralInfo.routing.busy_or_no_answer.destination_type)
      //       : -1,
      // });
      setRoutDetails(hgGeneralInfo?.routing?.busy_or_no_answer ?? {});
      setIncUsersSup(
        hgGeneralInfo?.voice_mail?.inc_user_sup != undefined
          ? hgGeneralInfo.voice_mail.inc_user_sup
          : true
      );
      setIsSequentialGroup(
        hgGeneralInfo?.routing?.ring_dist != undefined
          ? parseInt(hgGeneralInfo.routing.ring_dist)
          : 0
      );
      reset({
        extension: hgGeneralInfo?.extension
          ? parseInt(hgGeneralInfo.extension)
          : 0,
        disasterphonenumber: 0,
        name: hgGeneralInfo?.groupName ?? "",
        rec_calls: hgGeneralInfo?.rec_calls ?? false,
        disablecallroute: 0,
        disasterflag: 0,
        permit_user_spam: 0,
        adddids: [],
        removedids: [],
        addedUsers: [],
        removedUsers: [],
        enable_pre_anno: true,
        loc_id: hgGeneralInfo?.loc_id[0]?.id
          ? parseInt(hgGeneralInfo.loc_id[0].id)
          : 0,
        billing_grp: hgGeneralInfo?.billing_grp[0]?.group_id
          ? parseInt(hgGeneralInfo?.billing_grp[0]?.group_id)
          : 0,

        routing: {
          overall_ring_time:
            hgGeneralInfo?.routing?.overall_ring_time != undefined
              ? parseInt(hgGeneralInfo.routing.overall_ring_time)
              : 20,
          per_seq_ring_time:
            hgGeneralInfo?.routing?.per_seq_ring_time != undefined
              ? parseInt(hgGeneralInfo.routing.per_seq_ring_time)
              : 20,
          ring_dist:
            hgGeneralInfo?.routing?.ring_dist != undefined
              ? hgGeneralInfo.routing.ring_dist
              : 1,
          busy_or_no_answer: {
            value: "",
            destination_type: -1,
            phnumber:
              hgGeneralInfo?.routing?.busy_or_no_answer?.destination_type ===
                4 && hgGeneralInfo?.routing?.busy_or_no_answer?.title
                ? hgGeneralInfo?.routing?.busy_or_no_answer?.title
                : "",
            timeout_flag:
              hgGeneralInfo?.routing?.busy_or_no_answer?.timeout_flag !=
              undefined
                ? parseInt(
                    hgGeneralInfo.routing.busy_or_no_answer.timeout_flag
                  ) === 1
                  ? true
                  : false
                : false,
            timeout:
              hgGeneralInfo?.routing?.busy_or_no_answer?.timeout != undefined
                ? parseInt(hgGeneralInfo.routing.busy_or_no_answer.timeout)
                : 0,
            timeout_routing: "",
            timeout_dest_type: -1,
            cid_pass_flag:
              hgGeneralInfo?.routing?.busy_or_no_answer?.cid_pass_flag !=
              undefined
                ? parseInt(
                    hgGeneralInfo.routing.busy_or_no_answer.cid_pass_flag
                  ) === 1
                  ? true
                  : false
                : true,
            cid_pass: hgGeneralInfo?.routing?.busy_or_no_answer?.cid_pass
              ? hgGeneralInfo.routing.busy_or_no_answer.cid_pass
              : "",
          },
        },
        voice_mail: {
          vm_pin: hgGeneralInfo?.voice_mail?.vm_pin
            ? parseInt(hgGeneralInfo.voice_mail.vm_pin)
            : 0,
          play_msg_time_stmp:
            hgGeneralInfo?.voice_mail?.play_msg_time_stmp != undefined
              ? hgGeneralInfo.voice_mail.play_msg_time_stmp
              : false,
          email_notify:
            hgGeneralInfo?.voice_mail?.email_notify != undefined
              ? hgGeneralInfo?.voice_mail?.email_notify
              : true,
          email_address: hgGeneralInfo?.voice_mail?.email_address
            ? hgGeneralInfo.voice_mail.email_address
            : "",
          inc_user_sup:
            hgGeneralInfo?.voice_mail?.inc_user_sup != undefined
              ? hgGeneralInfo.voice_mail.inc_user_sup
              : true,
          vm_delete:
            hgGeneralInfo?.voice_mail?.vm_delete != undefined
              ? hgGeneralInfo.voice_mail.vm_delete
              : true,
          email_transcript:
            hgGeneralInfo?.voice_mail?.email_transcript != undefined
              ? hgGeneralInfo.voice_mail.email_transcript
              : true,
          broadcast_vm_to_account:
            hgGeneralInfo?.voice_mail?.broadcast_vm_to_account != undefined
              ? hgGeneralInfo.voice_mail.broadcast_vm_to_account
              : false,
          email_to_members:
            hgGeneralInfo?.voice_mail?.email_to_members != undefined
              ? hgGeneralInfo.voice_mail.email_to_members
              : false,
          email_to_sup:
            hgGeneralInfo?.voice_mail?.email_to_sup != undefined
              ? hgGeneralInfo.voice_mail.email_to_sup
              : false,
        },
      });

      setExecuteSettings(false);

      console.log(`After resetting of the data::: ${JSON.stringify(watch())}`);
    }
  }, [hgGeneralInfo, executeSetting]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll(".sticky-top .nav-link");
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
      if (lastLink.classList.contains("active")) {
        lastLink.classList.remove("active");
        const firstLink = scrollspyLinks[0];
        if (firstLink) {
          firstLink.classList.add("active");
        }
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  const handleImportAndSubmit = async () => {
    if (dirtyFields?.extension) {
      const result = await getImpExpStatusNew();
      if (result.status !== 0) {
        if (result.isOwnUser) {
          setShowImpExpRedirect(true);
        } else {
          const { userInfo } = result;
          if (userInfo?.isaccount) {
            setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
          } else {
            setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
          }
          exportwarningToggle();
        }
        return;
      }
    }
    handleSubmit(onSaveChanges)();
  };

  return (
    <>
      <MDBRow>
        <MDBCol
          size="2"
          md="2"
          lg="2"
          sm="12"
          className="col-sm-100 pr-0 leftTabs"
        >
          <MDBScrollspy container={containerRef}>
            <MDBScrollspyLink targetRef={section1}>
              {t("general")}
            </MDBScrollspyLink>
            <MDBScrollspyLink targetRef={section2}>
              {t("routing")}
            </MDBScrollspyLink>
            <MDBScrollspyLink targetRef={section3}>
              {t("Voicemail")}
            </MDBScrollspyLink>
          </MDBScrollspy>
        </MDBCol>

        <MDBCol
          size="12"
          md="10"
          sm="12"
          pr-0
          className="col-sm-100 pr-0 leftTabContent"
        >
          <FormProvider {...methods}>
            <div className="h-100 pr-5">
              <div
                id="element"
                ref={containerRef}
                className="scrollspy-example"
              >
                <section ref={section1} id="section-1">
                  <HGeneralSettings
                    selectedPhoneNum={selectedPhoneNum}
                    hgcode={hgcode}
                    // billingGroups={billingGroups}
                    setMessage={setMessage}
                    setHgUpdated={setHgUpdated}
                    greetingsInfo={greetingsInfo}
                    setIsloading={setIsloading}
                  />
                </section>

                <div className="routing-border mt-2"></div>
                <section ref={section2} id="section-2">
                  <div>
                    <HGRoutings
                      routDetails={routDetails}
                      assocCallFlows={assocCallFlows}
                      hgcode={hgcode}
                      executeSetting={executeSetting}
                      setIsloading={setIsloading}
                      // didSearchError={didSearchError}
                      // setdidSearchError={setdidSearchError}
                      // innerDidSearchError={innerDidSearchError}
                      // setinnerDidSearchError={setinnerDidSearchError}
                    />
                  </div>
                </section>

                <div className="routing-border mt-2"></div>
                <section ref={section3} id="section-3">
                  <HGVoicemail
                    incusersup={incusersup}
                    hgCode={hgcode}
                    greetingsInfo={greetingsInfo}
                  />
                </section>
              </div>
            </div>

            {isFieldModified && (
              <SaveChanges
                onClose={onCloseChanges}
                isFieldModified={isFieldModified}
                onSave={(e) => {
                  e.preventDefault();
                  handleImportAndSubmit();
                }}
              />
            )}
          </FormProvider>

          {showExportWarning && (
            <ImportProgressWarning
              warningToggle={exportwarningToggle}
              setShowWarning={setShowExportWarning}
              onOk={exportwarningToggle}
              message={warningMessage}
            />
          )}

          {showImpExpRedirect && (
            <ImpExpRedirectPopup
              onProceed={() => {
                setShowImpExpRedirect(false);
                setfirstRequest(true);
                importuserToggle();
              }}
              onCancel={() => setShowImpExpRedirect(false)}
            />
          )}

          <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
            <MDBModalDialog size="fullscreen">
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Import User Template</MDBModalTitle>
                </MDBModalHeader>
                <MDBModalBody className="pb-0">
                  <ImportUser
                    onClose={importuserToggle}
                    setIsloading={() => {}}
                    onShow={setimportUser}
                    show={importUser}
                    firstRequest={firstRequest}
                    setfirstRequest={setfirstRequest}
                  />
                </MDBModalBody>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>

          {hgUpdated && (
            <MDBAlert
              open
              className="alert-center"
              color="success"
              autohide
              position="bottom-right"
              delay={5000}
              onClose={() => setHgUpdated(false)}
            >
              <i className="fas fa-check-circle me-3"></i>
              <span className="alert-msg">{message}</span>
            </MDBAlert>
          )}
          {internalError && (
            <MDBAlert
              open
              className="alert-center"
              color="danger"
              autohide
              position="bottom-right"
              delay={5000}
              onClose={() => setInternalError(false)}
            >
              Internal Server Error
            </MDBAlert>
          )}
        </MDBCol>
      </MDBRow>
    </>
  );
}
